import { getCoreDataSecurityDataAccessSearchUserSlice } from './get';

export const { requestGetCoreDataSecurityDataAccessSearchUser, resetGetCoreDataSecurityDataAccessSearchUser } =
    getCoreDataSecurityDataAccessSearchUserSlice.asyncActionCreators;
